import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, Modal, message } from "antd";
import Sidebar from "../../Layouts/Sidebar";
import moment from "moment/moment";
import DataParser from "../../../utlits/Dataparser";
import DepartmentServices from "../../../Services/DepartmentServices";
import { Helmet } from "react-helmet";
import StatusBadge from "../../Reuseable/StatusBadge";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import secureLocalStorage from "react-secure-storage";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import TableSkeleton from "../../Reuseable/TableSkeleton";
import SocketService from "../../../Services/SocketService";

message.config({ zIndex: 1000000001 });

const Departments = () => {
  const navigate = useNavigate();
  const [Departments, setDepartments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [userPermissions, setuserPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [departmentName, setDepartmentName] = useState("");
  const [departmentNameEdit, setDepartmentNameEdit] = useState("");
  const [itemToDelete, setItemToDelete] = useState(null);
  const [editID, setEditID] = useState("");
  const [error, setError] = useState("");
  const companyId = DataParser.CompanyId();

  useEffect(() => {
    if (pageSize > 15) {
      setCurrentPage(1);
    }
  }, [pageSize]);

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const getDepartments = () => {
    setIsLoading(true);
    const companyId = DataParser.CompanyId();

    DepartmentServices.getCompanyDepartment(companyId, { params: { showAll: 1 } })
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }

        const dataset = res.data?.departments || [];
        setDepartments(dataset);
      })
      .catch((err) => {
        console.error("Error fetching departments:", err);
        message.error("Failed to load departments. Please try again!");
      })
      .finally(() => {
        setIsLoading(false); // ✅ Loader stops regardless of success or failure
      });
  };

  useEffect(() => {
    getDepartments();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  // 🟢 Socket Integration
  useEffect(() => {
    SocketService.connect();
    const companyId = DataParser.CompanyId();

    const handleDepartmentUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        console.log("🔔 Department update received:", data);
        getDepartments();
      }
    };

    SocketService.on("department_update", handleDepartmentUpdate);

    return () => {
      SocketService.off("department_update", handleDepartmentUpdate);
    };
  }, []);

  const handelDelete = (e, item) => {
    e.preventDefault();
    setItemToDelete(item);
    document.getElementById("openDeleteDeptModal").click();
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    const id = itemToDelete.id;
    const newData = Departments.filter((el) => el.id !== id);
    setDepartments(newData);
    document.getElementById("closeDeptDeleteModal").click();
    const companyId = DataParser.CompanyId();
    try {
      const res = await DepartmentServices.deleteDepartment(id, companyId);
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
      } else {
        message.success("Department deleted successfully!");
      }
      getDepartments();
    } catch (err) {
      console.error("Delete error:", err);
      message.error("Failed to delete department. Please try again!");
    }
    setItemToDelete(null);
  };

  const handleOpenUpdate = (e, item) => {
    e.preventDefault();
    setDepartmentNameEdit(item.name);
    setEditID(item.id);
  };

  const handelSubmit = (e) => {
    e.preventDefault();

    if (!departmentName || departmentName.trim() === "") {
      setError("Department name is required!");
      return;
    }

    const AddData = {
      name: departmentName.trim(),
      company_id: companyId,
    };

    DepartmentServices.createDepartment(AddData)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }

        if (res.Good === true) {
          message.success("Department created successfully!");
          const link = document.getElementById("DepartmentModalCreate");
          if (link) link.click();
          getDepartments();
          setDepartmentName("");
        } else {
          message.warning("Failed to create department. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Error creating department:", err);
        message.error(
          err.response?.data?.message ||
          "An unexpected error occurred while creating the department."
        );
      });
  };

  const handelEditSubmit = (e) => {
    e.preventDefault();

    if (!departmentNameEdit || departmentNameEdit.trim() === "") {
      setError("Department name is required!");
      return;
    }

    const AddData = {
      name: departmentNameEdit.trim(),
    };

    DepartmentServices.editDepartment(editID, AddData)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }

        if (res.Good === true) {
          message.success("Department updated successfully!");
          const link = document.getElementById("DepartmentModalEdit");
          if (link) link.click();
          getDepartments();
        } else {
          message.warning("Failed to update department. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Error updating department:", err);
        message.error(
          err.response?.data?.message ||
          "An unexpected error occurred while updating the department."
        );
      });
  };

  const clearCreateState = () => {
    setDepartmentName("");
    setError("");
  };

  const clearEditState = () => {
    setDepartmentNameEdit("");
    setEditID("");
    setError("");
  };

  const PaginatedData = paginate(Departments, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>Departments - Planit</title>
      </Helmet>
      {/* <Sidebar /> */}
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Departments</li>
                    </ol>
                    {userPermissions.indexOf("departments-create") !== -1 ? (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#createDepartmentModal"
                      >
                        Create Department
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Create Department
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Department Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={5} rows={6} />
                          ) : (
                            <>
                              {PaginatedData && PaginatedData.length > 0 ? (
                                PaginatedData.map((item, index) => (
                                  <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>{item.name}</td>
                                    {/* <td>
                                      {moment(item.updated_at).format(
                                        "D/MM/YYYY"
                                      )}
                                    </td> */}
                                    <td>
                                      {userPermissions.indexOf(
                                        "departments-edit"
                                      ) !== -1 ? (
                                        <StatusBadge
                                          item={item}
                                          api={
                                            DepartmentServices.updateDepartment
                                          }
                                        />
                                      ) : (
                                        <>
                                          {item.status === "1" ? (
                                            <span className="badge bg-success text-white">Active</span>
                                          ) : (
                                            <span className="badge bg-danger text-white">Deactive</span>
                                          )}
                                        </>
                                      )}
                                    </td>
                                    <td className="tableset">
                                      {userPermissions.indexOf(
                                        "departments-delete"
                                      ) !== -1 ? (
                                        <Link
                                          to="#"
                                          className="cursor-pointer iconscolor"
                                          onClick={(e) => handelDelete(e, item)}
                                        >
                                          <Tooltip title="Delete Department">
                                            <i className="uil-trash iconscolor" />
                                          </Tooltip>
                                        </Link>
                                      ) : (
                                        <span
                                          className="uil-trash iconscolor text-muted"
                                          style={{ cursor: "not-allowed", opacity: 0.5 }}
                                          title="You don't have permission to delete"
                                        />
                                      )}
                                      {userPermissions.indexOf(
                                        "departments-edit"
                                      ) !== -1 ? (
                                        <Link
                                          to="#"
                                          className="cursor-pointer iconscolor"
                                          onClick={(e) => handleOpenUpdate(e, item)}
                                          data-bs-toggle="modal"
                                          data-bs-target="#editDepartmentModal"
                                        >
                                          <Tooltip title="Edit Department">
                                            <i className="uil-pen iconscolor" />
                                          </Tooltip>
                                        </Link>
                                      ) : (
                                        <span
                                          className="uil-pen iconscolor text-muted"
                                          style={{ cursor: "not-allowed", opacity: 0.5 }}
                                          title="You don't have permission to edit"
                                        />
                                      )}
                                    </td>
                                  </tr>
                                ))) : (
                                <tr>
                                  <td colSpan="12" className="text-center">
                                    Add your first department by clicking the 'Create Department' button.
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>

                      {Departments.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={Departments.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden trigger for delete modal */}
        <div id="openDeleteDeptModal" data-bs-toggle="modal" data-bs-target="#deleteDepartmentModal" style={{ display: "none" }} />

        {/* Delete Confirmation Modal */}
        <div id="deleteDepartmentModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Department</h5>
                <button type="button" className="btn-close" id="closeDeptDeleteModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this department?</p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Create modal content */}
        <div
          id="createDepartmentModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelSubmit(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Create Department</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="DepartmentModalCreate"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearCreateState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="Name"
                      placeholder=" "
                      value={departmentName}
                      onChange={(e) => {
                        setDepartmentName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="Name">Department Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    onClick={(e) => handelSubmit(e)}
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    + Create Department
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Edit modal content */}
        <div
          id="editDepartmentModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelEditSubmit(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Department</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="DepartmentModalEdit"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearEditState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="NameEdit"
                      placeholder=" "
                      value={departmentNameEdit}
                      onChange={(e) => {
                        setDepartmentNameEdit(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="NameEdit">Department Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    onClick={(e) => handelEditSubmit(e)}
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Departments;
